import { useState } from "react";
import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";

export default function LatestArticlesGrid() {
  const [activeCategory, setActiveCategory] = useState<string>("all");

  const filteredArticles =
    activeCategory === "all"
      ? articles
      : articles.filter((a) => a.category === activeCategory);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-extrabold text-foreground-950">
              最新<span className="text-accent-500">爆料</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              塌房现场、深扒内幕、独家猛料一手掌握
            </p>
          </div>
          <Link
            to="/category/tahouse"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex gap-2 overflow-x-auto pb-3 mb-7 scrollbar-hide">
          <button
            onClick={() => setActiveCategory("all")}
            className={`shrink-0 px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${
              activeCategory === "all"
                ? "bg-primary-500 text-white"
                : "bg-background-50 text-foreground-600 hover:text-foreground-950 hover:bg-background-200/70"
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.slug)}
              className={`shrink-0 px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${
                activeCategory === cat.slug
                  ? "bg-primary-500 text-white"
                  : "bg-background-50 text-foreground-600 hover:text-foreground-950 hover:bg-background-200/70"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {filteredArticles.slice(0, 8).map((article) => (
            <ArticleCard
              key={article.id}
              slug={article.slug}
              title={article.title}
              category={article.category}
              coverImageSeq={article.coverImageSeq}
              thumbnailPrompt={article.thumbnailPrompt}
              publishedAt={article.publishedAt}
              views={article.views}
              isHot={article.isHot}
              isBreaking={article.isBreaking}
            />
          ))}
        </div>

        {filteredArticles.length > 8 && (
          <div className="text-center mt-8">
            <button className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 hover:bg-background-200/70 text-foreground-700 font-medium text-sm rounded-lg transition-all border border-background-300/60">
              加载更多爆料
              <i className="ri-arrow-down-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}